export default __webpack_public_path__ + "static/media/06-large.48e30836.jpg";